// @flow

import React from 'react';
import {
  Banner,
  Stack,
  Typography,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { Modal } from '@fortress-technology-solutions/fortress-component-library/Molecules_Fortress';
import { Form } from '@fortress-technology-solutions/fortress-component-library/Organisms';

import useTourBlockoutModal from './hooks';
import type { TourBlockoutModalProps } from './hooks';

const TourBlockoutModal = (props: TourBlockoutModalProps) => {
  const {
    ReactHookFormProps,
    fields,
    modalProps,
    handleCancel,
    formError,
    timezoneNote,
  } = useTourBlockoutModal(props);

  return (
    <Modal open={props.open} onClose={handleCancel} {...modalProps}>
      <Stack spacing={2}>
        {formError && (
          <Banner status="error" message={formError} sx={{ width: '100%' }} />
        )}
        <Typography variant="bodySmall" color="text.secondary">
          {timezoneNote}
        </Typography>
        <Form ReactHookFormProps={ReactHookFormProps} fields={fields} />
      </Stack>
    </Modal>
  );
};

export default TourBlockoutModal;
